import React from 'react';

import './Footer.css';

const links = [
  { href: '#caffetteria', label: 'Caffetteria' },
  { href: '#pausa-pranzo', label: 'Pausa pranzo' },
  { href: '#aperitivi', label: 'Aperitivi' },
  { href: '#contatti', label: 'Contatti' },
];

const Footer = () => (
  <footer className="footer">
    <div className="container footer__inner">
      <div>
        <p className="footer__name">L’angolo verde di Mauro e Aurora</p>
        <p className="footer__payoff">Il tuo bar di fiducia · Ceriano Laghetto</p>
      </div>
      <nav aria-label="Link del sito">
        <ul className="footer__links">
          {links.map((link) => (
            <li key={link.href}>
              <a href={link.href}>{link.label}</a>
            </li>
          ))}
        </ul>
      </nav>
    </div>
    <p className="container footer__copy">
      © {new Date().getFullYear()} L’angolo verde di Mauro e Aurora. Tutti i diritti riservati.
    </p>
  </footer>
);

export default Footer;
